import * as React from "react";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/shared/components/ui/sidebar";
import { useNavigate } from "react-router-dom";
import { LucideIcon } from "lucide-react";
import { Skeleton } from "./skeleton";

export function NavSecondary({
  items,
  skeleton = false,
  ...props
}: {
  items: {
    title: string;
    url: string;
    icon: LucideIcon;
    badge?: number | string | undefined | null;
    isHide?: boolean;
    onClick?: () => void;
  }[];
  skeleton?: boolean;
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const navigate = useNavigate();

  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {!skeleton &&
            items.map((item) => (
              <SidebarMenuItem key={item.title} className="font-500">
                <SidebarMenuButton
                  asChild
                  size="sm"
                  className="overflow-visible "
                  onClick={() => item?.onClick && item.onClick()}
                >
                  <p
                    className="cursor-pointer flex items-center gap-2"
                    onClick={() => navigate(item.url)}
                  >
                    <item.icon />
                    {!item.isHide && (
                      <span className="mt-0.5">{item.title}</span>
                    )}

                    {item?.badge != undefined && (
                      <div className=" -ml-1 rounded-full w-4 h-4  flex items-center justify-center bg-primary text-white">
                        <span className="text-[10px] font-500">
                          {item?.badge}
                        </span>
                      </div>
                    )}
                  </p>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          {skeleton && (
            <div className="space-y-[17px]">
              {Array.from({ length: 1 }).map((_, index) => (
                <div className="flex items-center gap-2">
                  <Skeleton
                    key={index}
                    className="w-5 h-5 bg-zinc-100 rounded-[6px]"
                  />
                  <Skeleton
                    key={index}
                    className="w-full h-5 bg-zinc-100 rounded-[6px]"
                  />
                </div>
              ))}
              {Array.from({ length: 1 }).map((_, index) => (
                <div className="flex items-center justify-between gap-2">
                  <div className="flex">
                    <Skeleton
                      key={index}
                      className="w-5 h-5 bg-zinc-100 rounded-[6px]"
                    />
                    <Skeleton
                      key={index}
                      className="w-4/6 h-5 bg-zinc-100 rounded-[6px]"
                    />
                  </div>
                  <Skeleton
                    key={index}
                    className="w-5 h-5 bg-zinc-100 rounded-[6px]"
                  />
                </div>
              ))}
            </div>
          )}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
